import './InitialPage.css';
import React, { useEffect } from 'react';
import { Carousel, Button } from 'react-bootstrap';
import AOS from 'aos';
import 'aos/dist/aos.css';
import eu from '../images/eu.png';
import topo from '../images/topo.png';
import SIdebar from './SIdebar';
import tecnologias from '../Data/tecnologias';
import links from '../Data/dataLinks';
import carousel from '../Data/carousel';
import { useLocation } from 'react-router-dom';


const InitialPage = () => {
  const location = useLocation()
  useEffect(() => {
    AOS.init({
      duration: 2000,
    });
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const renderCarouselItems = () => {
    return carousel.map((item) => (
      <Carousel.Item key={item.id} interval={800}>
        <img className='img-carrosel' src={item.src} alt={item.alt} />
        <Carousel.Caption className='caption'>
          <h3>{item.title}</h3>
          <p>{item.descreption}</p>
        </Carousel.Caption>
      </Carousel.Item>
    ));
  };

  const renderTecnologias = () => {
    return tecnologias.map((component) => (
      <div key={component.id} className='div-tec' data-aos="fade-down">
        <h6>{component.titulo}</h6>
        <img src={component.src} alt={component.descricao} />
      </div>
    ));
  };

  const renderLinks = () => {
    return links.map((link) => (
      <div key={link.id}>
        <h6>{link.alt}</h6>
        <a href={link.href}>
          <img src={link.image} alt={link.alt} className='img-src' data-aos="fade-down" />
        </a>
      </div>
    ));
  };

  return (
    <div>
      <header>
        <nav className="w3-tag w3-teal navbar">
          <ul className="elementos">
            <h2>PÁGINA OFICIAL</h2>
            <Carousel>{renderCarouselItems()}</Carousel>
          </ul>
        </nav>
      </header>
      {/* Importação do componente sidebar */}
      <SIdebar local={location.pathname}/>
      <div className="content">
        <div className="container-img">
          <div className='carousel'>
            <h4>Desenvolvedor fullStack!</h4>
            <div className='images'>{renderLinks()}</div>
          </div>
          <img
            src={eu}
            alt="Images"
            className='img'
            data-aos="zoom-in"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="3000"
          />
        </div>
        <ol className='tecnologias'>{renderTecnologias()}</ol>
        <Button
          type='button'
          className='button'
          onClick={scrollToTop}
        >
          <img src={topo} alt='topo' />
        </Button>
        <h4>Copyright &copy; 2023</h4>
      </div>
    </div>
  );
};

export default InitialPage;
